import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import CaspianDatePicker from '../BaseInputs/CaspianDatePicker';
import CaspianTimePickerInput from '../BaseInputs/CaspianTimePickerInput';

export const renderDateField = (props) => (
  <CaspianDatePicker
    selected={props.value}
    allowIndefinite={props.type === InputTypesEnum.DateWithIndefinite}
    allowEmpty={props.allowEmpty}
    utc={props.dateAsUtc}
    fieldName={props.fieldName}
    onChange={(e) => props.onChange(props.fieldName, e)}
  />
);

export const renderTimeField = (props) => (
  <CaspianTimePickerInput
    value={props.value}
    onChange={(newTime) => props.onChange(props.fieldName, newTime)}
    disabled={typeof props.disabled === 'function' ? props.disabled(props.editedItem) : props.disabled}
  />
);
